<template>
  <div>
    <div class="current-position">
      <img class="app-banner2" src="../assets/img/banner.png" alt="">
      <div class="current-position-text">
        <div class="app-container">
          <div class="current-position-logotext">Matrix</div>
        </div>
      </div>
    </div>
    <div class="survey-module">
      <div class="justify-between">
        <div class="survey-module-right">
          <div class="survey-module-right-title f-w">
            {{ menu.list[menu.list.findIndex( item => item.id == menu_id)].name }}
          </div>
          <!-- 考试管理 -->
          <ksglApp v-if="menu_id==1"/>
          <!-- 培训基地 -->
          <pxjdApp v-if="menu_id==2"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ksglApp from '@/components/pxjdgl/ksgl-app type.vue'
import pxjdApp from '@/components/pxjdgl/pxjd-app.vue'
export default {
  components:{
    ksglApp,
    pxjdApp
  },
  data(){
    return{
      loading:false,
      menu:{
        title:'培训基地管理',
        list:[
          {name:'考试管理',id:'1'},
          // {name:'培训基地',id:'2'},
        ]
      },
      menu_id:this.$route.query.id,
    }
  },
  methods:{
    menuFun(id){
      this.menu_id = id
    },
  }
}
</script>
<style scoped lang="css" src="../assets/css/base.css" />
<style>
.table-body .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: #8fc930 !important;
  border-color: #8fc930 !important;
}
.table-body .el-checkbox__input.is-focus  .el-checkbox__inner{
  border-color: #8fc930 !important;
}
.table-body .el-checkbox__inner:hover{
  border-color: #8fc930 !important;
}
.table-body .el-button--text {
  color: #8fc930 !important;
}
.table-body .el-button--text:hover {
  color: #72b701 !important;
}
</style>
